import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { TarifasService } from '../../services/tarifas.service';
import { TarifasEditComponent } from '../tarifas-edit/tarifas-edit.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';

@Component({
  selector: 'app-tarifas',
  templateUrl: './tarifas.component.html',
  styleUrls: ['./tarifas.component.scss']
})
export class TarifasComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: "Eliminar", field: 'id', suppressFilter: true, suppressSorting: true,
        template:
          `
            <a data-action-type="remove">Borrar</a>`,
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      {
        headerName: 'Editar', field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: "/tarifas/edit/", hyperlinkText: "Editar" },
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      { headerName: 'Nombre', field: 'nombre', minWidth: 150 },
      { headerName: 'Estado', field: 'activo', minWidth: 150, cellRendererFramework: CellImageFormatterComponent, cellRendererParams: { modo: "isActivo" } },
      { headerName: 'Fecha de inicio', field: 'fechaInicio', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: 'Fecha de fin', field: 'fechaFin', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: 'Tipo de calculo', field: 'tipoCalculo', minWidth: 150 },
      { headerName: 'Importe fijo', field: 'importeFijo', minWidth: 150 },
      { headerName: 'Porcentaje', field: 'porcentaje', minWidth: 150 },
      { headerName: 'Máx', field: 'max', minWidth: 150 },
      { headerName: 'Mín', field: 'min', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', minWidth: 150 },
      { headerName: 'ID', field: 'id', minWidth: 150 },
    ];

    return columnDefs;
  }

  dialogConfig: MatDialogConfig;

  constructor(private _TarifasService: TarifasService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
  }

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  public rowData: any;
  searchTerm: FormControl = new FormControl();

  ngOnInit() {
    this.getData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  getData() {
    this._TarifasService.getTarifasAll().subscribe(data => this.rowData = data);
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      let data = e.data;
      let actionType = e.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);

      }
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._TarifasService.deleteTarifa(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Esta tarifa está asociada a algún contrato, por lo que no se puede borrar. Si lo desea puede marcarla como inactiva.");
        }
        this.getData();
      });
    }
  }
}
